const storage = window.localStorage;
const STORAGE_ITEMS_SETTINGS_KEY = 'teamsLandingPageFilterItems';
const STORAGE_ITEMS_PAGE_SETTINGS_KEY = 'teamsLandingPageSortItems';

export interface localItemsSettings {
  activeFilters?: Record<string, unknown>;
  activeChipFilter?: string;
}

export interface localItemsPageSettings {
  activeSortOrder?: string;
  activeColumn?: string;
  activePerPage?: number;
}

export const getLocalItemsSettings = (): localItemsSettings =>
  JSON.parse(storage.getItem(STORAGE_ITEMS_SETTINGS_KEY)) || {};

export const getLocalItemsPageSettings = (): localItemsPageSettings =>
  JSON.parse(storage.getItem(STORAGE_ITEMS_PAGE_SETTINGS_KEY)) || {};

export const setLocalItemsSettings = (value: localItemsSettings): void => {
  storage.setItem(STORAGE_ITEMS_SETTINGS_KEY, JSON.stringify(value));
};

export const setLocalItemsPageSettings = (
  value: localItemsPageSettings,
): void => {
  storage.setItem(STORAGE_ITEMS_PAGE_SETTINGS_KEY, JSON.stringify(value));
};

export const clearLocalActiveFilters = (): void => {
  const localItemsSettings = getLocalItemsSettings();

  delete localItemsSettings.activeFilters;

  setLocalItemsSettings(localItemsSettings);
};
